import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getFundtype } from "../../../services";
import Controls from "../global/controls/Controls";
import {
  Grid,
} from "@material-ui/core";
import { useFormCreate, Form } from "./useFormCreate";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function CreateFund() {
  const navigate = useNavigate();
  const [fund, setfund] = useState([]);
  const [fundoption, setFundoption] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [formValues, setFormValues] = useState({
    fund_name: {
      value: "",
      error: false,
      errorMessage: "You must enter a first name",
    },
    fund_company: {
      value: "",
      error: false,
      errorMessage: "You must enter an last name",
    },
    fund_type: {
      value: "",
      error: false,
      errorMessage: "You must choose your fund type",
    },
  });
  const initialFValues = {
    fund_name: "",
    fund_company: "",
    fund_type: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("fund_name" in fieldValues)
    temp.fund_name = fieldValues.fund_name ? " " : " اسم الرصيد مطلوب";

    if ("fund_company" in fieldValues)
      temp.fund_company = fieldValues.fund_company ? " " : "اسم الشركة مطلوب";
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    errors,
    setErrors,
    addForm,
  } = useFormCreate(initialFValues, true, validate);

  const handleChange = (e) => {
    e.persist();
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setIsLoading(true);

    getFundtype()
      .then((res) => {
        setfund(res.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setfund([]);

        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleSubmit = (e) => {

    e.preventDefault();

    const data = {
      fund_name: formValues.fund_name,
      fund_company: formValues.fund_company,
      fund_type: fundoption,
    };

    axios
      .post(`${BaseUrl}/api/createfund`, data, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === true) {
          sweetalert("تم الاضافة بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          navigate("/getfund");
        } else {
          sweetalert("خطأ في عملية الإضافة", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          setFormValues({ ...formValues, error_list: res.data.error });
        }
      });
  };

  return (
    <div className="main-div">
      <h3 className="titlepage">إنشاء رصيد</h3>

      <Form className="form-group new-design" onSubmit={handleSubmit}>
        <div className="form-group">
          <Grid container maxWidth="sm" spacing={4}>
            <Grid item md={6} xs={12}>
              <Controls.Input
                placeholder="اسم الرصيد"
                name="fund_name"
                variant="outlined"
                fullWidth
                onChange={handleChange}
                className="form-control"
                error={errors.fund_name}
                type="text"
              />
            </Grid>

            <Grid item md={6} xs={12}>
              <div class="select">
                <select
                  className="form-control"
                  name="type"
                  class="select-text"
                  onChange={(e) => setFundoption(e.target.value)}
                >
                  <option selected disabled>
                    اختر العملية
                  </option>
                  {fund.map((opts, i) => (
                    <option key={i} value={opts.en_name}>
                      {opts.ar_name}
                    </option>
                  ))}
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
                <label class="select-label">النوع</label>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <Controls.Input
                label="اسم الشركة"
                name="fund_company"
                variant="outlined"
                fullWidth
                onChange={handleChange}
                className="form-control"
                error={errors.fund_company}
                type="text"
              />
            </Grid>
          </Grid>
        </div>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Controls.Button
            type="submit"
            text="حفظ"
            onClick={addForm}
            variant="contained"
            className="btn-submit"
          ></Controls.Button>
        </Grid>
      </Form>
    </div>
  );
}
